import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import V1Notice from './V1Notice';
import { isLoggedIn } from './auth';
import reportWebVitals from './reportWebVitals';

// V1 根站点网关: 默认显示"已切换到分组模式"提示页;
// 开发者模式(?dev=1 或 localStorage.v1_dev=1)才加载原 V1 应用(进度/数据均保留在后端, 不受影响)。
function isDevMode() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('dev') === '1') return true;
    if (window.localStorage.getItem('v1_dev') === '1') return true;
  } catch (e) {}
  return false;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {isDevMode() ? <App /> : <V1Notice />}
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 注册 Service Worker (PWA 离线支持)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('sw.js').catch(err => console.error('SW registration failed:', err));
    // SW 接管页面后, 再触发一次同步+预取, 确保预取请求被 SW 拦截并写入缓存
    navigator.serviceWorker.ready.then(() => {
      if (isDevMode() && isLoggedIn()) {
        import('./sync').then(m => m.triggerAutoSync()).catch(() => {});
      }
    }).catch(() => {});
  });
}
